import React from "react";
import { useNavigate } from "react-router-dom";
import Mashy from "@/components/Mashy";

export default function Login() {
  const nav = useNavigate();

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const handleGoogle = () => {
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 bg-[#F7F9FC]" data-testid="login-screen">
      <div className="w-full max-w-md card-chunky p-8 text-center flex flex-col items-center gap-5">
        <Mashy mood="happy" size={130} />
        <h1 className="font-display text-3xl text-gray-800">Welcome to Mashy</h1>
        <p className="text-gray-500 font-semibold">
          Hindi-speaking learners ke liye — fast, fun, voice-first English & Math.
        </p>
        <button
          onClick={handleGoogle}
          data-testid="login-google-button"
          className="btn-primary w-full text-lg"
        >
          <svg width="22" height="22" viewBox="0 0 48 48" className="bg-white rounded p-0.5">
            <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.3-.4-3.5z"/>
            <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 16.4 4 9.9 8.3 6.3 14.7z"/>
            <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2c-2 1.5-4.5 2.4-7.2 2.4-5.3 0-9.7-3.4-11.3-8L6 32.7C9.5 39.4 16.2 44 24 44z"/>
            <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.7 2-2 3.8-3.7 5.1l6.2 5.2C40.2 35.7 44 30.4 44 24c0-1.2-.1-2.3-.4-3.5z"/>
          </svg>
          Continue with Google
        </button>
        <p className="text-xs text-gray-400">
          Demo placeholders for AWS Cognito; Emergent Google Auth powers this MVP login.
        </p>
        <button onClick={() => nav("/")} data-testid="login-back-button" className="text-sm text-gray-500 underline">← Back</button>
      </div>
    </div>
  );
}
